import React from "react"

import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./MediumImage.scss"

const MediumImage = ({ section }) => {
  return (
    <Fade>
      <section
        className="medium-image"
        style={{ paddingTop: 90, paddingBottom: 90 }}
      >
        <figure
          className="medium-image__container"
          style={{
            backgroundImage: `url(${
              section.image.url ||
              "https://images.unsplash.com/photo-1640622307911-ee5870412ab5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHw0OXx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60"
            })`,
          }}
        />
        {section.image?.caption && (
          <figcaption>{section.image?.caption}</figcaption>
        )}
      </section>
    </Fade>
  )
}

MediumImage.propTypes = {
  section: PropTypes.object.isRequired,
}

export default MediumImage
